import React from 'react';
import './Feedback.css';

export default function FeedbackPage() {
  const testimonials = [
    {
      name: 'Suganthan S',
      role: 'Founder & CEO',
      company: 'MarketIQ Solutions',
      service: 'Enterprise Web & Strategy',
      rating: 5,
      quote: `Trevox engineered our entire digital enterprise platform with outstanding precision. Their technical execution, speed, and collaborative strategy turned our vision into a market-leading portal.`,
      metric: '+320%',
      metricLabel: 'Client Acquisition Growth',
      featured: true,
    },
    {
      name: 'Dr.K.R.Muralidharan',
      role: 'Chief Medical Director',
      company: 'Athika Child Care Hospital',
      service: 'Healthcare Platform & SEO',
      rating: 5,
      quote: `Our online patient appointment bookings and search visibility increased dramatically within weeks. Trevox delivered clean code, automated patient WhatsApp notifications, and zero downtime.`,
      metric: 'Top 3',
      metricLabel: 'Google Map Rankings',
    },
    {
      name: 'Aswanth S',
      role: 'Managing Director',
      company: 'EagleStar Enterprises',
      service: 'Industrial Web Engineering',
      rating: 5,
      quote: `Trevox built our corporate industrial catalog site with incredible speed. The lead inquiry system, WhatsApp integration, and mobile responsiveness helped us secure major commercial contracts.`,
      metric: '+250%',
      metricLabel: 'Inbound Lead Growth',
    },
    {
      name: 'Dr.S.Sundar',
      role: 'Operations Head',
      company: 'Medixca Pharmacy',
      service: 'E-Pharmacy & WhatsApp API',
      rating: 5,
      quote: `Our digital medicine ordering platform runs effortlessly. Trevox integrated instant prescription uploads and automated WhatsApp support, making medicine ordering seamless for our customers.`,
      metric: '100%',
      metricLabel: 'Order Fulfillment Speed',
    },
    {
      name: 'Ramalingam S',
      role: 'Head of Sales & Retail',
      company: 'KAG Tiles Retail',
      service: 'Interactive Catalog & Ads',
      rating: 5,
      quote: `Our luxury architectural tile catalog launched seamlessly. Customers love the interactive product browser and quick WhatsApp quote generation feature, driving high retail inquiries daily.`,
      metric: '+300%',
      metricLabel: 'Direct Buyer Inquiries',
    },

  ];

  const initials = (name) =>
    name.replace(/^(Dr\.\s*)/, '').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();

  const StarRating = ({ count }) => (
    <div className="fb-stars">
      {[...Array(count)].map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#f59e0b" stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );

  const featured = testimonials.find(t => t.featured);
  const rest = testimonials.filter(t => !t.featured);

  return (
    <section className="feedback-section" id="feedback">
      <div className="feedback-container">

        <div className="section-header">
          <div className="section-badge">
            <span>Client Stories</span>
          </div>
          <h2 className="section-title">What Our Clients Say About Working With Us</h2>
          <p className="section-subtitle">
            Real experiences and honest reviews from founders, medical directors, and business leaders who trust Trevox.
          </p>
        </div>

        {/* Summary bar */}
        <div className="fb-summary-bar">
          <div className="fb-summary-item">
            <span className="fb-summary-number">50+</span>
            <span className="fb-summary-label">Projects Delivered</span>
          </div>
          <div className="fb-summary-divider" />
          <div className="fb-summary-item">
            <span className="fb-summary-number">5.0 ★</span>
            <span className="fb-summary-label">Average Client Rating</span>
          </div>
          <div className="fb-summary-divider" />
          <div className="fb-summary-item">
            <StarRating count={5} />
            <span className="fb-summary-label">100% Satisfaction</span>
          </div>
          <div className="fb-summary-divider" />
          <div className="fb-summary-item">
            <span className="fb-summary-number">0</span>
            <span className="fb-summary-label">Missed Deadlines</span>
          </div>
        </div>

        {/* Featured card */}
        {featured && (
          <div className="fb-featured-card">
            <div className="fb-quote-mark">"</div>
            <div className="fb-featured-inner">
              <div className="fb-featured-left">
                <div className="fb-featured-pill">{featured.service}</div>
                <p className="fb-featured-quote">“{featured.quote}”</p>
                <div className="fb-featured-metric">
                  <span className="fb-metric-number">{featured.metric}</span>
                  <span className="fb-metric-label">{featured.metricLabel}</span>
                </div>
              </div>
              <div className="fb-featured-right">
                <StarRating count={featured.rating} />
                <div className="fb-author-row">
                  <div className="fb-avatar fb-avatar-lg">{initials(featured.name)}</div>
                  <div>
                    <div className="fb-author-name">{featured.name}</div>
                    <div className="fb-author-role">{featured.role}</div>
                    <div className="fb-author-company">{featured.company}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Regular cards grid */}
        <div className="fb-grid">
          {rest.map((t, i) => (
            <div key={i} className="fb-card">
              {/* Top row */}
              <div className="fb-card-top">
                <span className="fb-card-pill">{t.service}</span>
                <StarRating count={t.rating} />
              </div>

              {/* Quote */}
              <div className="fb-small-quote">"</div>
              <p className="fb-card-quote">“{t.quote}”</p>

              {/* Metric */}
              <div className="fb-card-metric">
                <span className="fb-metric-number-sm">{t.metric}</span>
                <span className="fb-metric-label-sm">{t.metricLabel}</span>
              </div>

              {/* Author */}
              <div className="fb-card-author">
                <div className="fb-avatar">{initials(t.name)}</div>
                <div className="fb-author-info">
                  <div className="fb-author-name">{t.name}</div>
                  <div className="fb-author-role">
                    {t.role} · <span className="fb-author-company">{t.company}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}